/**
 * The views that follow the project scope (owner decision 0.2, 19.10.2026):
 * API Requests (+ History), Boards, Documents, FTP/SFTP, DB Manager, Terminal,
 * Graph and Projects. Calendar, Chat, Vault, Settings and the rest stay
 * global, so the toolbar switcher is not shown there.
 */
const PROJECT_SCOPED_PANELS = new Set([
  'collections',
  'history',
  'task-manager.panel',
  'documents.panel',
  'ftp.panel',
  'db-manager.panel',
  'terminal.panel',
  'graph.panel',
  'projects.panel',
]);

export const isProjectScopedPanel = (activeTab) => PROJECT_SCOPED_PANELS.has(String(activeTab || ''));
